import { ChangeEvent, useReducer, useRef } from 'react';
import randomString from '../../../helpers/random-string';
import reducer from './reducer';
import Action from './reducer/action';
import { StateFile } from './reducer/state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useUploader(upload: (file: File) => unknown): any {
  const [{ files }, dispatch] = useReducer(reducer, {
    files: [],
  });

  const inputRef = useRef<HTMLInputElement>();

  const onInputChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0];
    const fileId = randomString();

    // eslint-disable-next-line no-param-reassign
    event.target.value = '';

    try {
      dispatch({
        type: Action.AddFile,
        payload: {
          id: fileId,
          title: file.name,
          size: file.size,
          status: 'uploading',
          value: null,
        },
      });

      dispatch({
        type: Action.UpdateFile,
        payload: {
          id: fileId,
          status: 'complete',
          value: await upload(file),
        },
      });
    } catch {
      dispatch({
        type: Action.UpdateFile,
        payload: {
          id: fileId,
          status: 'failed',
        },
      });
    }
  };

  const onRemove = (file: StateFile) =>
    dispatch({
      type: Action.RemoveFile,
      payload: file,
    });

  return {
    inputRef,
    onInputChange,
    onRemove,
    files,
  };
}
